function parseAgreements(agreements): Agreement[] {
  return Object.keys(agreements).map(key => {
    const agreement = agreements[key]
    return { id: +key, text: agreement.details.html, type: agreement.details.type }
  })
}

export default parseAgreements
